import { Merchant } from '@applyonline/shared'
import i18n from '@if/core/i18n'
import { useCallback, useMemo, useState } from 'react'
import { } from '../../services/query-string'
import { CreditApplication, buildCreditApplicationSchemaObject } from '../../types/Schemas/CreditApplicationSchema'

const STEP_LIST_FOR_APPLICANT = ['personal-information', 'address', 'employment', 'review']

export function useStepListForApplicant() {
  return STEP_LIST_FOR_APPLICANT
}

export function useNewApplicationStepList(isSinglePayment = false) {
  return useMemo(() => {
    const ret = [...STEP_LIST_FOR_APPLICANT]

    if (isSinglePayment) {
      ret.splice(2, 1) // remove employment step
    }

    return ret
  }, [isSinglePayment])
}

export const buildDefaultCreditApplication = (merchant: Merchant, isSinglePayment = false): CreditApplication => {
  const defaultCreditApp: CreditApplication = {
    ...(buildCreditApplicationSchemaObject().getDefault() as unknown as CreditApplication),
    isSinglePayment,
  }

  defaultCreditApp.merchantId = merchant.id
  defaultCreditApp.applicant.languageId = i18n.language === 'fr' ? 0 : 1

  return defaultCreditApp
}

export const useSessionStorage = <T,>(keyName: string, initialValue: T) => {
  const savedInfo = sessionStorage.getItem(keyName)
  const initValue = savedInfo ? (JSON.parse(savedInfo) as T) : initialValue

  const [value, setValue] = useState<T>(initValue)

  const saveValue = useCallback(
    (newValue: T) => {
      const json = JSON.stringify(newValue)
      sessionStorage.setItem(keyName, json)
      setValue(newValue)
    },
    [keyName],
  )

  return [value, saveValue] as const
}
